import {
  formatBirthDateForApi,
  formatBirthTimeForApi,
  normalizeBirthPlaceLabel,
  type SoulMapProfileForm,
} from './soulmap-profile';

function getBirthPlaceFingerprint(form: SoulMapProfileForm): string {
  if (!form.birthPlace) {
    return '';
  }

  const { label, lat, lng } = form.birthPlace;
  return [normalizeBirthPlaceLabel(label), lat, lng].join('|');
}

/** Only birth details feed the chart, so preference edits must not requeue a document. */
export function haveSoulMapBirthDetailsChanged(
  before: SoulMapProfileForm,
  after: SoulMapProfileForm
): boolean {
  return (
    formatBirthDateForApi(before.birthDate) !==
      formatBirthDateForApi(after.birthDate) ||
    formatBirthTimeForApi(before.birthTime) !==
      formatBirthTimeForApi(after.birthTime) ||
    getBirthPlaceFingerprint(before) !== getBirthPlaceFingerprint(after)
  );
}

export function hasCompleteSoulMapBirthDetails(
  form: SoulMapProfileForm
): boolean {
  return Boolean(
    form.birthDate.trim() && form.birthTime.trim() && form.birthPlace
  );
}

function normalizeOptOutKey(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, ' ');
}

function getBirthDetailsOptOutCohorts(): string[] {
  const raw =
    import.meta.env.VITE_SOULMAP_BIRTH_DETAILS_OPT_OUT_COHORTS?.trim();
  if (!raw) {
    return [];
  }

  return raw.split(',').map(normalizeOptOutKey).filter(Boolean);
}

export function hasSoulMapBirthDetailsOptOuts(): boolean {
  return getBirthDetailsOptOutCohorts().length > 0;
}

/**
 * Every cohort the user has in the tenant must be listed; one unlisted cohort
 * keeps the modal. Matched by tenant slug + cohort name rather than ids, so
 * one entry works across environments.
 */
export function isSoulMapBirthDetailsOptedOut(
  tenantSlug: string | null | undefined,
  cohorts: { name: string }[] | undefined
): boolean {
  if (!tenantSlug || !cohorts?.length) {
    return false;
  }

  const optOuts = getBirthDetailsOptOutCohorts();
  return cohorts.every((cohort) =>
    optOuts.includes(normalizeOptOutKey(`${tenantSlug}:${cohort.name}`))
  );
}
